import { SVGProps } from 'react';

export const BancontactIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={800} height={800} viewBox='0 0 32 32' {...props}>
    <path d='M28.516 13.027h-9.433l-5.723 6.692H2.079l3.041-3.583H1.495c-.823 0-1.495.687-1.495 1.531v3.24c0 .843.672 1.531 1.495 1.531H18.74c.823 0 1.948-.511 2.5-1.14l2.609-2.964 4.624-5.26zm-1.5 1.702-1 1.14zm3.489-5.166H13.306c-.823 0-1.947.511-2.5 1.135l-7.317 8.281h9.396l5.823-6.692h11.229l-3.016 3.583h3.584c.823 0 1.495-.692 1.495-1.536v-3.235c0-.844-.672-1.536-1.495-1.536zm-2.494 4.03-.5.568-.131.156z' />
  </svg>
);
